/**
 * Imágenes de relleno para artículos sin foto.
 *
 * Antes se pedían a via.placeholder.com, un servicio externo que ya no
 * responde: cada artículo sin imagen provocaba un 503 y el service worker
 * registraba el fallo. En el carrusel de vídeos además se reintentaba en
 * bucle, porque el onError apuntaba al mismo servicio caído.
 *
 * Son SVG en data URI, así que no salen a la red y funcionan sin conexión.
 */

const ROJO = '#c82318';

const svg = (ancho, alto, emoji, fondo = ROJO) => {
  const tamano = Math.round(Math.min(ancho, alto) * 0.38);
  const contenido = `<svg xmlns="http://www.w3.org/2000/svg" width="${ancho}" height="${alto}" viewBox="0 0 ${ancho} ${alto}">` +
    `<rect width="${ancho}" height="${alto}" fill="${fondo}"/>` +
    `<text x="50%" y="50%" dy=".35em" text-anchor="middle" font-size="${tamano}">${emoji}</text>` +
    `</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(contenido)}`;
};

export const PLACEHOLDER_ARTICULO = svg(200, 150, '📖');
export const PLACEHOLDER_ARTICULO_GRANDE = svg(375, 300, '📖', '#8B5CF6');
export const PLACEHOLDER_MINIATURA = svg(150, 150, '📖');
export const PLACEHOLDER_VIDEO = svg(320, 180, '🎥');
export const PLACEHOLDER_AUDIO = svg(300, 200, '🎵');
